mutation EntityTagPaymentCreate($input: EntityTagPaymentCreateInput!) {
  entityTagPaymentCreate(input: $input) {
    entityTags {
      id
      tagId
      entityId
      appId
    }
  }
}
